import { ofType } from 'redux-observable';
import { mapTo } from 'rxjs/operators';

const pingEpic = action$ => action$.pipe(
  ofType('PING'),
  mapTo({ type: 'PONG' })
);

export default pingEpic;